export default __webpack_public_path__ + "static/media/neusoft-logo.3ff98b15.svg";